<section fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="16px">
  <figure fxFlex="1/3" [style.padding]="padding|async">
    <figcaption>
      <h3>
        Aim to remove the lengthy screening
        process and tedious paperwork
        common to banks and other lending
        companies.
      </h3>
    </figcaption>
  </figure>
  <figure fxFlex="1/3" [style.padding]="padding|async">
    <h3>
      Ensure efficient processing by using the
      latest computer software in handling
      loan applications.
    </h3>
  </figure>
  <figure fxFlex="1/3" [style.padding]="padding|async">
    <h3>
      We do not deduct fees from your
      requested loan amount, meaning you
      will get the full loan amount that was
      approved.
    </h3>
  </figure>
</section>
